import { render, staticRenderFns } from "./LbDropdown.vue?vue&type=template&id=296ef2c1"
import script from "./LbDropdown.vue?vue&type=script&lang=js"
export * from "./LbDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports